"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.9922 15.9922c.9712 0 1.8155.3236 2.3738.7812l1.2679-1.5467c-.9434-.7734-2.2451-1.2345-3.6417-1.2345-1.4001 0-2.6853.4632-3.6262 1.2345l1.268 1.5467c.5607-.4597 1.3904-.7812 2.3582-.7812zM11 9.5c0 .8284-.6716 1.5-1.5 1.5S8 10.3284 8 9.5 8.6716 8 9.5 8s1.5.6716 1.5 1.5zm3.5 1.5c.8284 0 1.5-.6716 1.5-1.5S15.3284 8 14.5 8 13 8.6716 13 9.5s.6716 1.5 1.5 1.5z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12c0 4.9706-4.0294 9-9 9s-9-4.0294-9-9 4.0294-9 9-9 9 4.0294 9 9zm-2 0c0 3.866-3.134 7-7 7s-7-3.134-7-7 3.134-7 7-7 7 3.134 7 7z"
  })];
};

exports.default = _default;